<!--
 * @Descripttion:
 * @Author: cuiyingchun
 * @Date: 2021-04-08 08:44:13
 * @LastEditors: liang
 * @LastEditTime: 2021-09-13 14:21:45
 * @Introduce: 举报管理
-->
<template>
<div class="box">
  <h1 class="perText1">我的证书</h1>
    <div class="bg">
   <el-card shadow="never" class="aui-card--fill">
      <el-form ref="dataForm" :model="dataForm" @keyup.enter.native="getDataList(1)" class="dataForm" :inline="true">
        <el-form-item>
          <el-date-picker v-model="dataForm.year" type="year" value-format="yyyy" placeholder="年度" clearable style="width: 200px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.libraryName" placeholder="考试名称" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.certificateName" placeholder="发证机关" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type='danger' @click="resetHandle()">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onApplyCertificate()" v-if="showApplyBtn">申请证书</el-button>
        </el-form-item>
      </el-form>
      <el-table
          v-loading="dataListLoading" :data="dataList"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border>
          <el-table-column type="index" label="序号" width="60" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="libraryName" min-width="180" label="考试名称" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="year"  min-width="100" label="年度" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="certificateName"  min-width="180" label="发证机关" header-align="center" align="center" ></el-table-column>
          <!-- <el-table-column prop="createDate"  min-width="180" label="发证时间" header-align="center" align="center" ></el-table-column> -->
          <el-table-column label="操作" width="100" fixed="right" header-align="center" align="center" >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleSee(scope.row)">查看证书</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-button type="primary" @click="deleteHandle()">批量删除</el-button> -->
        <div style="text-align:right;margin-top:20px;">
        <el-pagination
         background
        :current-page="page"
        :page-size="limit"
        :page-sizes="[10]"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
        </div>
      <!-- <div class="imgdialogbox" v-if="imgdialog" @click="imgdialog=false">
        <div class="imgdialog">
          <img src="@/assets/img/close.png" class="close">
          <img :src="zssrc" class="zs">
        </div>
      </div> -->
   </el-card>
    </div>
    <applyCertificate v-if="applyVisible" @click-close="onCloseApplyCertificate"></applyCertificate>
</div>
</template>
<script>
import moment from 'moment'
import applyCertificate from './applyCertificate'
export default {
  data () {
    return {
      dataForm: {
        year: '',
        libraryName: '',
        certificateName: ''
      },
      dataListLoading: false,
      visible: false,
      page: 1,
      limit: 10,
      total: 1,
      dataList: [],
      applyVisible: false,
      showApplyBtn: false
    }
  },
  components: { applyCertificate },
  created () {
    // this.dataForm.year = this.moment().format('YYYY')
    this.$store.dispatch('setNavIndex', '-2')
    this.getDataList(1)
    this.canApplyCertificate()
  },
  methods: {
    moment,
    handleSee (row) {
      // this.imgdialog = true
      // this.zssrc = window.SITE_CONFIG['minio'] + row.path
      window.open(process.env.VUE_APP_minio + row.path)
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      window.scrollTo(0, 0)
      this.getDataList()
    },
    getDataList (page) {
      // let user = JSON.parse(localStorage.getItem('user'))
      this.dataListLoading = true
      this.$get(`/exam/etpassexamcertificate/userCertificateListPage`, {
        page: page || this.page,
        limit: 10,
        // userId: user.id,
        ...this.dataForm
      })
        .then((res) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            this.dataList = []
            this.total = 0
            return false
          }
          this.dataList = res.data.list
          this.dataList.forEach((item, index) => {
            item._index =
              this.page - 1 === 0
                ? index + 1
                : index + 1 < this.limit
                  ? (this.page - 1) * this.limit + (index + 1)
                  : this.page * this.limit
          })
          this.total = res.data.total
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    resetHandle () {
      this.dataForm = {
        year: '',
        libraryName: '',
        certificateName: ''
      }
      this.page = 1
      this.getDataList()
    },
    onApplyCertificate () {
      this.applyVisible = true
    },
    onCloseApplyCertificate () {
      this.applyVisible = false
    },
    canApplyCertificate () {
      this.$get('/exam/etofflineexampersonne/isShowButtonSQZS')
        .then(res => {
          const { code = 500, data } = res
          if (code === 0) {
            this.showApplyBtn = data
          }
        })
    }
  }
}
</script>
<style scoped lang='scss'>
.perText1{
    font-size: 22px;
  }
.imgdialogbox{position: fixed;z-index: 99922;left: 0;top: 0;bottom: 0;right:0;background:rgba(0, 0, 0,.5);}
.imgdialog{width: 560px;height: 560px; position: fixed;left: 50%;margin-left: -280px;top: 150px;background:rgba(255, 255, 255,.5);}
.imgdialog .close{position: absolute;right: -21px;top: -21px;cursor: pointer;z-index: 33;}
.zs{width: 100%;}
.box {
  min-height: calc(100vh - 430px);
  overflow: hidden;
  padding-left:20px;
  .bg {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
